import React from 'react'
import {Modal} from 'antd'
import ModalImg from '~/assets/img/zash/zash_modal.svg'
import {DigitalReceiptsModalProps} from './props'

import styles from './styles.scss'

export const DigitalReceiptsModal: React.FC<DigitalReceiptsModalProps> = ({
    open,
    footer,
    children,
    onClose
}) => {
    return (
        <Modal open={open} onCancel={onClose} width={700} footer={footer}>
            <div className={styles.root}>
                <img src={ModalImg} />
            </div>
            {children}
        </Modal>
    )
}
